<template>
  <div class="card">
    <div class="card-body" style="min-height: 22rem">
      <div class="clearfix">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mb-4">Sample Orders for Collection</h4>
          <div class="float-end">
            <div class="flex-nowrap input-group input-group-sm mb-3">
              <label class="input-group-text bg-light">Date</label>
              <date-picker v-model="ordersCollectionDateSelected" class="dashboard-datepicker" fixed-position="top-right" @input="ordersCollectionDateSelectedFn"></date-picker>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-4" />
      <div>
        <data-table :columns="ordersForDeliveryColumns" :rows="sampleOrdersForCollectionReport.objects" :has-pagination="false" :has-search="false">
          <template v-slot:actions="slotProps">
            <div v-if="slotProps.row.availableStatusChanges.length > 0 && checkForPermission(change_order_status_permission)">
              <select :id="slotProps.row.publicId" @change="changeStatus($event, slotProps.row.publicId)" class="dashboard-order-select">
                <option selected></option>
                <option v-for="status in slotProps.row.availableStatusChanges" :value="status.publicId" :key="status.publicId">{{ status.orderStatusName }}</option>
              </select>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {SAMPLE_ORDERS_DUE_FOR_COLLECTION_ON_A_DAY} from "@/gql";
import moment from "moment";
import {permissions} from "@/router/permissions";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
export default {
  name: "SampleOrdersForCollection",
  components: {DataTable},
  data(){
    return {
      ordersCollectionDateSelected: new Date(),
      ordersForDeliveryColumns: [
        {
          field: 'sampleOrderTaker.name',
          label: 'Customer'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      sampleOrdersForCollectionReport: {
        objects: []
      },
      perPage: 30,
      currentPage: 1,
      loading: false,
      deliveryLoading: false,
      collectionDates: [moment().format('YYYY-MM-DD')],
      selectedStatus: '',
      change_order_status_permission: permissions.cancel_sample_order_permission,
    }
  },
  apollo: {
    sampleOrdersForCollectionReport: {
      query: SAMPLE_ORDERS_DUE_FOR_COLLECTION_ON_A_DAY,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          collectionDates: this.collectionDates
        }
      }
    },
  },
  computed: {
    isToday(){
      return this.collectionDates[0] === moment().format('YYYY-MM-DD')
    },
  },
  methods: {
    ... mapActions({
      changeSampleOrderStatus: 'orders/changeSampleOrderStatus',
    }),
    ordersCollectionDateSelectedFn(){
      this.collectionDates = [moment(this.ordersCollectionDateSelected).format('YYYY-MM-DD')]
    },
    async changeStatus(event, sampleOrderId){
      const data = {sampleOrderId: sampleOrderId ,statusId: event.target.value}
      await this.changeSampleOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrdersForCollectionReport.refetch()
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
